import { APPS, STORAGE } from '../constants';
import { LocalStorageService } from '../services/LocalStorageService';

export const ChannelUtil = {


    format: (app: string, channel?: string) => {

        const account = LocalStorageService.get(STORAGE.ACCOUNT_SELECTED)

        if (+account.account_id === 188 && channel && channel.toLowerCase() === 'convenio del bot') {
            return 'BOT';
        }

        switch (app.toUpperCase()) {
            case APPS.WHATSAPP_STANDAR:
                
                return 'WhatsApp';
            case APPS.WHATSAPP_BUSINESS:
            case 'WA':
                
                return 'WhatsApp Business';
            case APPS.RCS:
                
                return 'RCS';
            case APPS.CALL:
                
                return 'Llamada';
            case APPS.SMS:
                
                return 'SMS';
        
            default:
                return app
        }
    },

    
}